import segmentPlugin from '@analytics/segment'
import Analytics from 'analytics'

import { AnalyticsAction, AnalyticsPageAction, AnalyticsTrackAction, AnalyticsActionType } from 'types/analytics.type'
import { excludeFalsy, isString } from 'utils/common'

export const analytics = Analytics({
  app: 'tccc-our-work',
  plugins: [
    segmentPlugin({
      writeKey: process.env.REACT_APP_SEGMENT_ANALYTICS_KEY,
    }),
  ].filter(excludeFalsy),
})

export const reset = () => {
  analytics.reset()
}

const getAnalyticsTenantAzId = () => analytics?.getState()?.user?.traits?.tenantAzId

const trackPage = ({ payload }: AnalyticsPageAction) => {
  const analyticsTenantAzId = getAnalyticsTenantAzId()
  if (analyticsTenantAzId) {
    analytics.page(
      {
        title: payload,
      },
      {
        agency: analyticsTenantAzId,
      },
    )
  }
}

const trackAction = ({ payload }: AnalyticsTrackAction) => {
  const analyticsTenantAzId = getAnalyticsTenantAzId()
  if (analyticsTenantAzId) {
    if (isString(payload)) {
      analytics.track(payload, {
        agency: analyticsTenantAzId,
      })
    } else {
      const { action, params } = payload

      analytics.track(action, {
        agency: analyticsTenantAzId,
        ...Object.fromEntries(params.map(({ key, value }) => [key, value])),
      })
    }
  }
}

export const trackAnalytics = (action: AnalyticsAction) => {
  switch (action.type) {
    case AnalyticsActionType.page:
      trackPage(action)
      break

    case AnalyticsActionType.action:
      trackAction(action)
      break

    default:
      break
  }
}

export const ANALYTICS_EVENTS = {
  PAGEVIEW: {
    PAGE_VIEW_MAIN: 'pg_pv_nma_submissions',
  },
  ACTION: {
    SEARCHBAR_SEARCH: 'pg_act_nma_submissions_searchbar_search',
    CATEGORY_SELECT: 'pg_act_nma_submissions_searchbar_category',
    SUBMISSION_SELECT: 'pg_act_nma_submissions_searchbar_submission',
    OU_SELECT: 'pg_act_nma_submissions_searchbar_ou',
    YEAR_SELECT: 'pg_act_nma_submissions_searchbar_ou',
    AWARDS_ITEM_CLICK: 'pg_act_nma_submissions_productexperience_submissioncard',
    CAROUSEL_LEFT: 'pg_act_nma_submissions_productexperience_carouselleft',
    CAROUSEL_RIGHT: 'pg_act_nma_submissions_productexperience_carouselright',
  },
}
